import type {Mapper} from '@automapper/core';
import {constructUsing, createMap, forMember, mapFrom} from '@automapper/core';
import type {IMapping} from '@igp/shared/auto-mapper';
import type {ReferralLinkConfig} from '@igp/shared/contract/pam';

import {
    ReferralLinkConfigQueryFieldsTypeName,
    ReferralLinkConfigSortKeysTypeName,
    ReferralLinkConfigTypeName,
    ReferralLinkConfigViewModelKeysTypeName,
    ReferralLinkConfigViewModelTypeName,
} from './constants';
import type {
    ReferralLinkConfigQueryFields,
    ReferralLinkConfigSortKeys,
    ReferralLinkConfigViewModel,
    ReferralLinkConfigViewModelKeys,
} from './types';

export class ReferralLinkConfigMapping implements IMapping {
    createMapping(mapper: Mapper): void {
        createMap<ReferralLinkConfig, ReferralLinkConfigViewModel>(
            mapper,
            ReferralLinkConfigTypeName,
            ReferralLinkConfigViewModelTypeName,
            forMember(
                vm => vm.aal_group_name,
                mapFrom(m => m.aal_group_name)
            ),
            forMember(
                vm => vm.referral_link_base_url,
                mapFrom(m => m.referral_link_base_url ?? undefined)
            ),
            forMember(
                vm => vm.license,
                mapFrom(m => m.license)
            )
        );

        createMap<ReferralLinkConfigViewModelKeys, ReferralLinkConfigQueryFields>(
            mapper,
            ReferralLinkConfigViewModelKeysTypeName,
            ReferralLinkConfigQueryFieldsTypeName,
            constructUsing((m: ReferralLinkConfigViewModelKeys) => {
                const mapping: Record<ReferralLinkConfigViewModelKeys, ReferralLinkConfigQueryFields> = {
                    aal_group_name: 'aal_group_name',
                    referral_link_base_url: 'referral_link_base_url',
                    license: 'license',
                };
                return mapping[m];
            })
        );

        createMap<ReferralLinkConfigViewModelKeys, ReferralLinkConfigSortKeys>(
            mapper,
            ReferralLinkConfigViewModelKeysTypeName,
            ReferralLinkConfigSortKeysTypeName,
            constructUsing((m: ReferralLinkConfigViewModelKeys) => {
                const mapping: Record<ReferralLinkConfigViewModelKeys, ReferralLinkConfigSortKeys> = {
                    aal_group_name: 'aal_group_name',
                    referral_link_base_url: 'aal_group_name', // referral_link_base_url is not sortable, map to aal_group_name
                    license: 'aal_group_name', // license is not sortable, map to aal_group_name
                };
                return mapping[m];
            })
        );

        createMap<ReferralLinkConfigSortKeys, ReferralLinkConfigViewModelKeys>(
            mapper,
            ReferralLinkConfigSortKeysTypeName,
            ReferralLinkConfigViewModelKeysTypeName,
            constructUsing((m: ReferralLinkConfigSortKeys) => {
                const mapping: Record<ReferralLinkConfigSortKeys, ReferralLinkConfigViewModelKeys> = {
                    aal_group_name: 'aal_group_name',
                };
                return mapping[m];
            })
        );
    }
}
